import { Provider } from 'react-redux';
import { WagmiConfig } from 'wagmi';
import { store } from './store/createStore';
import Authlogic from './Authlogic';
import { getClient } from './helpers/getLibrary';
import { WalletProvider } from './wallet/walletContext';

const App = () => {
  return (
    <Provider store={store}>
      <WagmiConfig client={getClient()}>
        <WalletProvider>
          <Authlogic />
        </WalletProvider>
      </WagmiConfig>
    </Provider>
  );
};

export default App;
